const normalizePathname = (pathname) => {
  const value = String(pathname || "/").trim() || "/";
  if (value === "/") return "/";
  return value.replace(/\/+$/, "") || "/";
};

const matchesRoute = (pathname, route) => {
  const path = normalizePathname(pathname);
  return path === route || path.startsWith(`${route}/`);
};

const EXCLUDED_ROUTES = ["/dashboard", "/user", "/support/hot-rpc", "/nora", "/tamagotchi"];

export const BOTTOM_NAV_SECONDARY_GROUPS = [
  {
    id: "referral",
    path: "/referral",
    activePaths: ["/referral"],
    requiresPreviewAccess: true,
  },
  {
    id: "staking",
    path: "/staking",
    activePaths: ["/staking"],
  },
  {
    id: "craft",
    path: "/craft",
    activePaths: ["/craft"],
    requiresAdminAccess: true,
  },
  {
    id: "market",
    path: "/market",
    activePaths: ["/market"],
  },
  {
    id: "crafting",
    path: "/crafting",
    activePaths: ["/crafting"],
    hidden: true,
  },
  {
    id: "mechanics",
    path: "/mechanics",
    activePaths: ["/mechanics", "/house", "/mine"],
    hidden: true,
  },
  {
    id: "games",
    path: "/games",
    activePaths: ["/games"],
    hidden: true,
  },
];

export function shouldShowBottomNav(pathname) {
  const path = normalizePathname(pathname);
  return !EXCLUDED_ROUTES.some((route) => matchesRoute(path, route));
}

export function getBottomNavSecondaryId(pathname) {
  const path = normalizePathname(pathname);
  return BOTTOM_NAV_SECONDARY_GROUPS.find((group) =>
    group.activePaths.some((route) => matchesRoute(path, route))
  )?.id || null;
}

export function getBottomNavActiveId(pathname) {
  const path = normalizePathname(pathname);
  if (path === "/" || matchesRoute(path, "/home")) return "home";
  if (matchesRoute(path, "/claim")) return "claim";
  if (matchesRoute(path, "/leaderboard")) return "leaderboard";
  if (matchesRoute(path, "/wallet")) return "wallet";
  if (getBottomNavSecondaryId(path)) return "more";
  return "home";
}

export { normalizePathname };
